import { defineComponent as _defineComponent } from 'vue'
import { useRtDialogBase } from '@/composables/useRtDialogBase'
import RtCommonOtherJobButton from '@/components/realtimeTransfer/RtCommonOtherJobButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MedleyLinkDialog',
  setup(__props) {

const base = useRtDialogBase({
  openDialogEventName: 'open-medleylink-dialog',
  // MedleyLink は handler 自体は sendMedleyConsult を使うが、hub イベント名は
  // 'send-medleylink-consult' で名前空間を分けている（既存仕様維持）。
  primaryConsultEventName: 'send-medleylink-consult',
  primaryConsultHandlerKey: 'sendMedleyConsult',
  defaultPermissionType: 5,
  defaultClientId: 'medley_link',
  defaultDialogName: 'medley_link-dialog',
  afterApplyInfo: () => {
    base.isAgree.value = true
  }
})

// テンプレート互換のための別名（旧 API キーを維持）
const medleyLinkModalVisible = base.modalVisible
const isSendedMedley = base.isSended
const closeMedleyLinkDialog = base.closeDialog
const onMedleyLinkModalOpened = base.onModalOpened
const onMedleyLinkModalClosed = base.onModalClosed
const handleBeforeClose = base.handleBeforeClose
const fullscreenLoading = base.fullscreenLoading
const dialogInfo = base.dialogInfo
const useGoogleAdsTag = base.useGoogleAdsTag
const clientId = base.clientId
const permissionType = base.permissionType
const isAgree = base.isAgree
const onLogoImageLoad = base.onLogoImageLoad
const sendMedleyConsult = base.sendMedleyConsult
const showOtherJobButton = base.showOtherJobButton
const rtOtherJobButtonLabel = base.rtOtherJobButtonLabel
const onRtOtherJobBtnClick = base.onRtOtherJobBtnClick

return { __sfc: true,base, medleyLinkModalVisible, isSendedMedley, closeMedleyLinkDialog, onMedleyLinkModalOpened, onMedleyLinkModalClosed, handleBeforeClose, fullscreenLoading, dialogInfo, useGoogleAdsTag, clientId, permissionType, isAgree, onLogoImageLoad, sendMedleyConsult, showOtherJobButton, rtOtherJobButtonLabel, onRtOtherJobBtnClick, RtCommonOtherJobButton }
}

})